var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_menu_header"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"backBeforePage",on:{"click":_vm.handleRouterBack}},[_c('i',{staticClass:"el-icon-arrow-left"})]),(_vm.showFileBtn)?_c('div',{staticClass:"fileBtn",on:{"click":function () {
        _vm.$emit('clickFileBtn')
      }}},[_vm._v(" 附件 ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }